<app-header></app-header>

<div class="form-page-wrapper cambio-password">
	<h2 class="text-center">Crea la tua nuova password</h2>
	<div class="testo mb-3">La tua nuova password deve essere diversa rispetto a quelle utilizzate in precedenza.</div>
	<div class="form-group">
		<label class="form-label-kf" for="pwdNuova">Nuova password</label>
		<div class="form-input-wrapper">
			<input
				id="pwdNuova"
				[type]="showNew() ? 'text' : 'password'"
				class="form-control-kf"
				[class.is-invalid]="error()"
				placeholder="••••••••"
				[ngModel]="nuovaPassword()"
				(ngModelChange)="nuovaPassword.set($event); checkPassword($event)" />
			<i class="form-input-icon bi" [class.bi-eye]="!showNew()" [class.bi-eye-slash]="showNew()" (click)="showNew.set(!showNew())"></i>
		</div>
		<div class="nota">minimo 8 caratteri e almeno una 3 delle seguenti regole: 1 maiuscola, 1 minuscola, 1 numero, 1 carattere speciale.</div>
	</div>

	<div class="form-group">
		<label class="form-label-kf" for="pwdConferma">Conferma nuova password</label>
		<div class="form-input-wrapper">
			<input
				id="pwdConferma"
				[type]="showConfirm() ? 'text' : 'password'"
				class="form-control-kf"
				[class.is-invalid]="error()"
				placeholder="••••••••"
				[ngModel]="confermaNuovaPassword()"
				(ngModelChange)="confermaNuovaPassword.set($event)" />
			<i class="form-input-icon bi" [class.bi-eye]="!showConfirm()" [class.bi-eye-slash]="showConfirm()" (click)="showConfirm.set(!showConfirm())"></i>
		</div>
		@if (error()) {
			<span class="form-error">
				<i class="bi bi-exclamation-circle-fill"></i>
				{{ errorMsg() }}
			</span>
		}
	</div>

	<div style="margin-top:24px;">
		<button class="btn-kf-primary" (click)="cambia()" [disabled]="loading()">
			@if (loading()) {
				<span class="spinner-border spinner-border-sm me-2"></span>
			}
			CAMBIA PASSWORD
		</button>
	</div>

	<div class="text-center mt-3 mb-5 pb-5 link-cancel" (click)="goBack()">Torna indietro</div>
</div>
